export const parseImportString = value =>
	value === null || value === undefined ? value : String(value).trim().replace(/\s+/g, ' ')

export const matchKey = value =>
	value === null || value === undefined ? '' : String(value).replace(/\s+/g, '').toLowerCase()
